import React, { useEffect } from "react";
import { Nav, Row, Tab } from "react-bootstrap";
import { Link } from "react-router-dom";
import EdButton from "../edbutton/edButton";
import GenericTabs from "../GenericTabs";
import CustomDateFilter from "./CustomDateFilter";
import _ from "underscore";
import TwinBtns from "@frameworks/web/components/Reports/RebrandedReports/GenericComponents/TwinBtns";
import { BtnDNAproperties, EBtnDNAproperties, } from "@frameworks/web/components/Reports/RebrandedReports/constant";
const propEquality = (prevProps, nextProps) => {
    return _.isEqual(prevProps, nextProps);
};
const EachFilter = React.memo((eachFilterprops) => {
    var _a;
    return (
    // <div id="filter-show-hide" className="filterasset-drop-body">
    React.createElement("ul", { className: "filterasset-drop-body" },
        React.createElement("div", { className: `d-flex mb-2 ${(eachFilterprops === null || eachFilterprops === void 0 ? void 0 : eachFilterprops.clear) && (eachFilterprops === null || eachFilterprops === void 0 ? void 0 : eachFilterprops.selectAll)
                ? "justify-content-between"
                : "justify-content-end"}` },
            (eachFilterprops === null || eachFilterprops === void 0 ? void 0 : eachFilterprops.selectAll) &&
                eachFilterprops.selectedType === "checkbox" && (React.createElement("li", { className: "d-flex inside-list align-items-center common-checkbox-custom common-radio-button-custom" },
                React.createElement("input", { type: eachFilterprops.selectedType, onChange: (e) => {
                        eachFilterprops.selectedAllHandler(e, eachFilterprops.filterName);
                    }, checked: eachFilterprops.list.every((x) => x.selected), name: eachFilterprops.propertyKey, value: "Select All" }),
                React.createElement("label", { className: "bodylist-title DMSan_14_500 txt_primaryGrey" }, "Select All"))),
            (eachFilterprops === null || eachFilterprops === void 0 ? void 0 : eachFilterprops.clear) && (React.createElement("div", { className: "" },
                React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: eachFilterprops.customClearText
                        ? eachFilterprops.customClearText
                        : eachFilterprops.selectedType === "radio"
                            ? "Clear Selection"
                            : "Clear All", className: "dm-fam", onClick: () => eachFilterprops.clearSectionWise(eachFilterprops.filterName) })))),
        ((_a = eachFilterprops.list) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
            eachFilterprops.list.map((val, idx) => {
                return (React.createElement("div", { key: idx, className: "each-filter-parent" },
                    React.createElement("li", { className: "d-flex inside-list align-items-center common-checkbox-custom common-radio-button-custom" },
                        React.createElement("input", { type: eachFilterprops.selectedType, onChange: (e) => {
                                eachFilterprops.updateChecked(e, eachFilterprops.filterName, idx);
                            }, value: val.key, checked: val.selected }),
                        React.createElement("label", { className: "bodylist-title px-1" }, val.title)),
                    val.selected && val.customDateFilter && (React.createElement(CustomDateFilter, { customDateFilter: eachFilterprops === null || eachFilterprops === void 0 ? void 0 : eachFilterprops.customDateFilter, applyDate: (data) => {
                            eachFilterprops === null || eachFilterprops === void 0 ? void 0 : eachFilterprops.setCustomDateFilter(data);
                        } }))));
            })));
}, propEquality);
export const SidebarFilter = React.memo((props) => {
    const [selected, setSelected] = React.useState(props.links);
    const [activeKey, setActiveKey] = React.useState(props.defaultActiveKey ? props.defaultActiveKey : props.links[0].eventKey);
    // const [selectAll, setSelectAll] = React.useState(false);
    const selectedAllHandler = (e, filterName) => {
        if (e && filterName && e.target.type === "checkbox") {
            setSelected((prevState) => {
                return prevState.map((gcFilter) => {
                    if (gcFilter.filterName === filterName) {
                        gcFilter.list.map((x) => {
                            x.selected = e.target.checked;
                        });
                    }
                    return gcFilter;
                });
            });
        }
    };
    const clearSectionWise = (filterName) => {
        setSelected((prevState) => {
            return prevState.map((gcFilter) => {
                if (gcFilter.filterName === filterName) {
                    gcFilter.list.map((val) => {
                        val.selected = false;
                        if (val.childlist && val.childlist.list) {
                            return val.childlist.list.map((child) => {
                                child.selected = false;
                            });
                        }
                    });
                }
                return gcFilter;
            });
        });
    };
    const updateChecked = (e, filterName, key, type) => {
        if (e && filterName && e.target.type === "radio") {
            setSelected((prevState) => {
                return prevState.map((gcFilter) => {
                    if (gcFilter.filterName === filterName) {
                        gcFilter.list.map((val) => {
                            if (val.childlist && val.childlist.list) {
                                return val.childlist.list.map((child) => {
                                    if (child.key == e.target.value)
                                        child.selected = true;
                                    else
                                        child.selected = false;
                                });
                            }
                            else {
                                if (val.key == e.target.value)
                                    val.selected = true;
                                else
                                    val.selected = false;
                            }
                        });
                    }
                    return gcFilter;
                });
            });
        }
        else if (e && filterName && e.target.type === "checkbox") {
            setSelected((prevState) => {
                return prevState.map((gcFilter) => {
                    if (gcFilter.filterName === filterName) {
                        gcFilter.list[key].selected = e.target.checked;
                    }
                    return gcFilter;
                });
            });
            props.customCheckBoxFunction &&
                props.customCheckBoxFunction(e, key, filterName);
        }
        else if (type && filterName && type === "tab") {
            setSelected((prevState) => {
                return prevState.map((gcFilter) => {
                    if (gcFilter.filterName === filterName) {
                        gcFilter.list.map((x, i) => {
                            if (i === key) {
                                x.selected = true;
                            }
                            else {
                                x.selected = false;
                            }
                        });
                    }
                    return gcFilter;
                });
            });
        }
    };
    const disableApply = (links) => {
        return links.every((x) => x.list.every((y) => {
            if (y.childlist)
                return y.childlist.list.every((m) => m.selected === false);
            return y.selected === false;
        }));
    };
    useEffect(() => {
        if (!props.applyBtn && props.setSelectedFilter) {
            props.setSelectedFilter(selected);
        }
    }, [selected]);
    React.useEffect(() => {
        if (props.defaultActiveKey)
            setActiveKey(props.defaultActiveKey);
    }, [props.defaultActiveKey]);
    React.useEffect(() => {
        if (props.links)
            setSelected([...props.links]);
    }, [props.links]);
    return (React.createElement("div", { className: `footer-sidebar-generic ${props.externalClassName}` },
        (props === null || props === void 0 ? void 0 : props.header) && props.header,
        React.createElement(Tab.Container, { id: "left-tabs-example", defaultActiveKey: props.links[0].eventKey },
            React.createElement(Row, { className: "m-0" },
                React.createElement("div", { className: "leftsidebar pe-0 px-0 col-4" },
                    React.createElement(Nav, { variant: "pills", className: "flex-column", activeKey: props.defaultActiveKey }, selected &&
                        selected.map((link, idx) => {
                            return (React.createElement(Nav.Item, null,
                                React.createElement(Nav.Link, { as: Link, to: link.route ? link.route : "", active: link.eventKey === activeKey, onClick: () => {
                                        props.handleTitle &&
                                            props.handleTitle(link.filterName);
                                        setActiveKey(link.eventKey);
                                    }, eventKey: link.eventKey, key: idx },
                                    React.createElement("span", { className: "posrel" },
                                        link.filterName,
                                        link.showFDot && (React.createElement("sup", { className: "notificationlock-filter-dot" }, "."))))));
                        }))),
                React.createElement("div", { className: "rightsidebar px-0 col-8" },
                    React.createElement(Tab.Content, { className: "bg_white" }, selected &&
                        selected.length > 0 &&
                        selected.map((ele, idx) => {
                            var _a;
                            return (React.createElement(Tab.Pane, { key: idx, eventKey: ele.eventKey, active: ele.eventKey === activeKey, className: "commonscroll-new max-height250 " },
                                ele.customJSXElement && ele.customJSXElementdata,
                                ((_a = ele.list) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                                    (ele.selectType === "tab" ? (React.createElement(GenericTabs, { defaultActiveKey: ele.list[0].key, tabsArray: ele.list.map((x) => {
                                            var _a, _b;
                                            return {
                                                title: x.title,
                                                eventKey: x.key,
                                                tabContent: (React.createElement(EachFilter, { list: x.childlist.list, filterName: x.childlist.filterName, propertyKey: x.childlist.eventKey, selectedType: x.childlist.selectType, clear: (_a = x === null || x === void 0 ? void 0 : x.childlist) === null || _a === void 0 ? void 0 : _a.clear, customClearText: (_b = x === null || x === void 0 ? void 0 : x.childlist) === null || _b === void 0 ? void 0 : _b.customClearText, selectedAllHandler: selectedAllHandler, updateChecked: updateChecked, clearSectionWise: clearSectionWise, setCustomDateFilter: props === null || props === void 0 ? void 0 : props.setCustomDateFilter, customDateFilter: props.customDateFilter })),
                                            };
                                        }), callBackFunction: (key) => {
                                            let index = null;
                                            ele.list.filter((x, idx) => x.key == key ? (index = idx) : null);
                                            updateChecked(null, ele.filterName, index, "tab");
                                        } })) : (React.createElement(EachFilter, { list: ele.list, filterName: ele.filterName, selectedType: ele.selectType, propertyKey: ele.eventKey, clear: ele === null || ele === void 0 ? void 0 : ele.clear, selectAll: ele === null || ele === void 0 ? void 0 : ele.selectAll, customClearText: ele === null || ele === void 0 ? void 0 : ele.customClearText, selectedAllHandler: selectedAllHandler, updateChecked: updateChecked, clearSectionWise: clearSectionWise, setCustomDateFilter: props === null || props === void 0 ? void 0 : props.setCustomDateFilter, customDateFilter: props.customDateFilter })))));
                        })))),
            props.cancelAndApply ? (
            // <div className="bottom-contents px-3 p-2 topboxsshadow-button">
            //   <BuySellBtn
            //     rightButton={{
            //       btnTyp: "midnight-blue",
            //       value: "Apply",
            //       className: "w-100",
            //       disabled: disableApply(props.links),
            //       onClick: () => props.handleApply(selected),
            //     }}
            //     cancelAction={() => props?.setOpenDrawer(false)}
            //     refreshLabelTitle={""}
            //   />
            React.createElement(TwinBtns, { parentClass: "buy-sell-btns buy-sell-btns-spacing ", leftBtn: Object.assign(Object.assign({}, BtnDNAproperties[EBtnDNAproperties.CANCEL]), { disabled: disableApply(props.links), onClick: () => props === null || props === void 0 ? void 0 : props.setOpenDrawer(false) }), rightBtn: Object.assign(Object.assign({}, BtnDNAproperties[EBtnDNAproperties.APPLY]), { disabled: disableApply(props.links), onClick: () => {
                        props.handleApply(selected);
                        if (props.setActiveKey)
                            props.setActiveKey(activeKey);
                    } }) })) : (
            // </div>
            props.applyBtn && (React.createElement("div", { className: "bottom-contents px-3 p-2 topboxsshadow-button" },
                React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Apply Filters", className: "w-100", onClick: () => {
                        props.handleApply(selected);
                        if (props.setActiveKey)
                            props.setActiveKey(activeKey);
                    } })))))));
}, propEquality);
